import script from "./DashboardsMobileSubsidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardsMobileSubsidebar.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardsMobileSubsidebar.vue?vue&type=style&index=0&id=2d6631a4&lang=scss"

const __exports__ = script;

export default __exports__